import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { AzureCWSensorController } from '../controller/AzureCWSensorController';

export class AzureCWSensorComponent extends BaseSensorWebComponent {
  public controller!: AzureCWSensorController;

  constructor() {
    super();
    this.sensorType = SensorType.AZURE_CW;
    this.initialSetup({
      controllerConstructor: AzureCWSensorController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
